import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const superDashboardRoutes = [
  {
    path: 'dashboard',
    component: DummyRouter,
    meta: {
      permissionAction: PermissionActions.SuperAdminLimitedDashboardView,
    },
    children: [
      {
        path: '',
        component: () => import('./SuperAdminDashboard.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedDashboardView,
        },
      },
    ],
  },
]
